import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const dictionaryService = {
  organizationRolePermissionType, getCountries, getCountriesCallCodes, getDocumentsActionHistTypes
};

const dictionaryCache = new Map();
const DOCUMENTS_ACTION_HIST_TYPE = 'documents-action-history-types';

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  get curLocation() {
    return process.env.BASE_URL;
  }
};

function extract(r) {
  return r.data;
}

async function organizationRolePermissionType() {
  return axios.get(model.baseUrl + 'dictionary/organizationrolepermissiontype').then(extract);
}

let countriesLoadPromiseResolver: Function;
let countriesLoadPromise = new Promise(resolve => {
  countriesLoadPromiseResolver = resolve;
});
let countries = [];
let countriesCallCodes = [];
let firstCountriesRead = true;

function loadCountries() {
  axios.get(`${model.curLocation}static/countries.json`).then(c => {
    countries = c.data;
    countriesCallCodes = c.data
      .filter(c => c.callingCodes.length > 0)
      .reduce((arr, v) => {
        return arr.concat(
          v.callingCodes.length === 1
            ? [{ name: v.name, value: v.callingCodes[0].replace(' ', '') }]
            : v.callingCodes.map(cc => {
              return { name: v.name, value: cc.replace(' ', '') };
            })
        );
      }, []);
    countriesLoadPromiseResolver();
  });
}

async function getCountries() {
  if (firstCountriesRead) {
    firstCountriesRead = false;
    loadCountries();
  }

  await countriesLoadPromise;

  return countries.slice();
}

async function getCountriesCallCodes() {
  if (firstCountriesRead) {
    firstCountriesRead = false;
    loadCountries();
  }

  await countriesLoadPromise;

  return countriesCallCodes.slice();
}

async function getDocumentsActionHistTypes() {
  return new Promise((resolve, reject) => {
    if (dictionaryCache.has(DOCUMENTS_ACTION_HIST_TYPE)) {
      const data = dictionaryCache.get(DOCUMENTS_ACTION_HIST_TYPE);
      resolve(data);
    } else {
      return axios.get(model.baseUrl + 'dictionary/documentsgetactionhisttypes')
        .then(extract)
        .then(data => {
          if (data && data.length) {
            dictionaryCache.set(DOCUMENTS_ACTION_HIST_TYPE, data);
          }
          resolve(data);
        })
        .catch(err => reject(err));
    }
  });
}
